export default "__VITE_ASSET__f6e4121c__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg7__"